import api from "PFCore/api";

import { TemplatesResponse } from "../show/types";
import { Template } from "../types";

export const fetchTemplates = (): Promise<TemplatesResponse> =>
  api({
    url: "admin/interest_questionnaires",
    method: "GET"
  });

export interface EditTemplateArgs {
  id: number;
  data: Partial<Template>;
}

export const editTemplate = ({ id, data }: EditTemplateArgs): Promise<Template> =>
  api({
    url: `admin/interest_questionnaires/${id}`,
    method: "PUT",
    data
  });

export const fetchTemplate = (id: number): Promise<Template> =>
  api({
    url: `admin/interest_questionnaires/${id}`,
    method: "GET"
  });
